<template>
<!--  form-section повешан, потому что companies-section используется еще в профиле, вне диалога -->
  <section class="form-section grid-block">
    <header> Юридические лица
      <VLink
        material="add"
        @click="CompaniesService.createCompany(localPartner, onCompaniesChanged)"
      >
        Добавить юр лицо
      </VLink>
    </header>

    <div class="content">
      <VDataGridV2
        :data="companies"
        :context-menu="contextMenu"
        layout="fill"
        @row:dblclick="row => CompaniesService.editCompany(row, onCompaniesChanged)"
      >
        <VDataGridColumnV2
          id="name"
          label="Юр. лицо"
          width="35%"
          content-class="ellipsis"
        >
          <template #default="{ row }">
            {{ row.name }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="inn"
          label="ИНН"
          width="30%"
        >
          <template #default="{ row }">
            <template v-if="row.additionalAttributes?.inn">
              {{ row.additionalAttributes?.inn?.value }}
            </template>
            <template v-else>
              --
            </template>
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="kpp"
          label="КПП"
          width="30%"
        >
          <template #default="{ row }">
            <template v-if="row.additionalAttributes?.kpp">
              {{ row.additionalAttributes?.kpp?.value }}
            </template>
            <template v-else>
              --
            </template>
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>
    </div>
  </section>
</template>

<script lang="ts">

import Partner          from '@/domains/Partners/Partner';
import CompaniesService from "@/domains/Companies/CompaniesService";

export default defineComponent({
  name: 'CompaniesSection',

  props: {
    localPartner: {
      type:    Partner,
      default: null,
    },
  },

  emits: [
    'companies:updated',
  ],

  setup() {
    return {
      CompaniesService,
    };
  },

  computed: {
    companies() {
      return this.localPartner.companies || [];
    },

    /**
     * Меню грида: фабрика замыкает партнёра и колбэк обновления.
     * includeOpen по умолчанию true — двойной клик не единственный путь открытия.
     * onChange = companies:updated наверх → PartnerCard перечитает партнёра,
     * грид обновится через :data. readOnly здесь не нужен — секция всегда
     * редактируемая (в отличие от карточки, которая может открываться на просмотр).
     */
    contextMenu() {
      return CompaniesService.getContextMenu(
        this.localPartner,
        () => this.$emit('companies:updated'),
      );
    },
  },

  methods: {
    onCompaniesChanged() {
      this.$emit('companies:updated');
    },
  },
});
</script>
